import React from "react"
import { has } from "lodash"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faCheckCircle, faTimesCircle, faSpinner, faEdit } from "@fortawesome/free-solid-svg-icons"

class ImageUpload extends React.Component{
    constructor(){
        super()
        this.state = {
            fileName: "",
            imgUrl: null,
            imgError: "",
            isLoading: false,
            savedMessage: ""
        }
        this.imgFile = React.createRef()
        this.imgRegex = /^.+(\.png)$/
    }
    handleChange = async (e) =>{
        if (this.props.noEdit) {
            return;
        }
        e.preventDefault()
        this.setState({
            imgError: "",
            isLoading: true,
            savedMessage: ""
        })
        var file = this.imgFile.current.files[0]
        if (await this.validate(file) === true){
            let key = this.props.name;
            if (this.props.isRemoteImagePlaceholder) {
                key = 'remoteImage/' + file.name.substring(0, file.name.lastIndexOf(".png"));
            }
            const PUTAPI = this.props.api + key;
            fetch(PUTAPI,{
                method: "PUT",
                body: (() => {
                    let d = new FormData();
                    d.append('file', file);
                    return d;
                })()
            })
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")){ throw data } 
                this.setState({
                    imgUrl: this.props.isRemoteImagePlaceholder ? null : data.Url,
                    isLoading: false,
                    savedMessage: <><FontAwesomeIcon icon={faCheckCircle} /> Saved!</>
                })
            })
            .then(()=>this.props.getAppConfig())
            .catch(data => {
                this.setState({
                    isLoading: false,
                    imgError: `Server: ${data.error}`
                })
            })
        }
        else{
            this.setState({
                isLoading: false
            })
        }
        this.imgFile.current.value = ""
    }
    //checking image size is async. so the overall validate is async as well.
    validate = async (file) => {
        if (this.imgFile.current.files.length === 0){
            this.setState({
                imgError: "This field is required.",
                isLoading: false
            })
            return false
        }
        if (!this.imgRegex.test(file.name)){
            this.setState({
                imgError: "Please only upload .png files",
                isLoading: false
            })
            return false
        }
        else if (file.size > this.props.fileSize){
            this.setState({
                imgError: `Please only upload files up to ${(file.size / Math.pow(1024,2)).toFixed(2)} MB`,
                isLoading: false
            })
            return false
        }
        else if (this.props.resolution !== undefined && await this.checkImgResolution(file) === false){
            this.setState({
                imgError: "Please only upload images of specified size.",
                isLoading: false
            })
            return false
        }
        if (this.props.isRemoteImagePlaceholder && this.props.remoteImages !== null) {
            for (let item of this.props.remoteImages) {
                if (item.key === file.name.substring(0, file.name.lastIndexOf(".png"))) {
                    this.setState({
                        imgError: "Remote images must have unique names.",
                        isLoading: false
                    })
                    return false
                }
            }
        } 
        return true
    }
    checkImgResolution = (file) => {
        var resolution = this.props.resolution
        return new Promise((resolve, reject) =>{
            var img = new Image()
            img.onload = () => {
                var width = img.naturalWidth,
                    height = img.naturalHeight;
                var result = ( width === resolution && height === resolution )
                if (result === false) URL.revokeObjectURL(file)
                resolve(result)
            }
            img.src = URL.createObjectURL(file)
        })
    }
    componentDidMount(){
        this.setState({
            imgUrl: this.props.imgUrl
        })
    }
    componentDidUpdate(prevProps){
        if (prevProps.imgUrl !== this.props.imgUrl){
            this.setState({
                imgUrl: this.props.imgUrl
            })
        }
    }
    deleteImage = (e) =>{
        e.preventDefault()
        fetch(this.props.api,{
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                key: this.props.name,
            })
        })
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.props.getAppConfig()
            this.setState({
                isLoading: false,
                imgUrl: null
            })
        })
        .catch(data => {
            this.setState({
                isLoading: false,
                imgError: `Server: ${data.error}`
            })
        })
    }
    render(){
        const { name, instruction, disabled } = this.props
        const { imgUrl } = this.state
        return(
            <div className={`imgInputWrapper ${disabled ? "disabled" : ""}`}>
                <input disabled={disabled || this.props.noEdit} type="file" id={name} accept=".png" name={name}
                    onChange={this.handleChange} ref={this.imgFile} />
                {this.state.isLoading 
                ? <label className="uploadImg" tabIndex="0" htmlFor={name}>
                    <FontAwesomeIcon icon={faSpinner} spin />
                </label>
                : imgUrl === null
                    ?
                    <label className="uploadImg" tabIndex="0" htmlFor={name}>
                        <FontAwesomeIcon icon={faPlus} />
                    </label> 
                    : <>
                    <label className="uploadImg img" htmlFor={name}
                    style={{backgroundImage: `url(${imgUrl})`}}>
                        {disabled || this.props.noEdit
                            ?null
                            :<>
                            <FontAwesomeIcon className="editBtn" transform="right-2" icon={faEdit} />
                            <FontAwesomeIcon className="deleteBtn"  tabIndex="0" icon={faTimesCircle} onClick={this.deleteImage} />
                            </>
                        }
                    </label>
                    <p className="savedMessage">{this.state.savedMessage}</p>
                    </>
                }
                <p className="imgInstruction">{instruction}</p>
                <p className="imgError">{this.state.imgError}</p>
            </div>
        )
    }
}

export default ImageUpload